/* Etiqueta: carrito lateral, selector de sabor y oferta, fecha de entrega. Sin dependencias. */
(function () {
  'use strict';

  var cfg = window.themeConfig || {};
  var routes = cfg.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var offer = cfg.offer || { enabled: false, buy: 2, get: 1, unitsPerPack: 24 };
  var gift = cfg.gift || { enabled: false };
  var bundle = (Number(offer.buy) || 2) + (Number(offer.get) || 1);

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cap(str) { str = String(str || ''); return str.charAt(0).toUpperCase() + str.slice(1); }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    format = format || cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delimit(value, precision, thousands, decimal) {
      var fixed = (value / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(re);
    var out;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': out = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = delimit(cents, 2, ' ', ','); break;
      default: out = delimit(cents, 2, ',', '.');
    }
    return format.replace(re, out);
  }

  function freeFor(qty) { return offer.enabled ? Math.floor(qty / bundle) * (Number(offer.get) || 1) : 0; }
  function paidFor(qty) { return qty - freeFor(qty); }

  /* ---------- Cart API ---------- */
  function jsonOrThrow(res) {
    return res.json().then(function (data) {
      if (!res.ok) throw new Error(data.description || data.message || 'No se pudo actualizar el carrito.');
      return data;
    });
  }
  function cartGet() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(jsonOrThrow);
  }
  function cartAdd(formData) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST', body: formData, credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(jsonOrThrow);
  }
  function cartAddItems(items) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(jsonOrThrow);
  }
  function cartChange(key, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    }).then(jsonOrThrow);
  }

  /* ---------- Header count ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
    $$('[data-cart-toggle]').forEach(function (el) {
      el.setAttribute('aria-label', 'Abrir carrito, ' + count + (count === 1 ? ' artículo' : ' artículos'));
    });
  }

  /* ---------- Drawer rendering ---------- */
  var drawer = $('[data-cart-drawer]');
  var panel = drawer ? $('[data-cart-panel]', drawer) : null;
  var useDrawer = !!drawer && cfg.cartType === 'drawer';
  var lastFocus = null;

  function giftIcon() {
    return '<svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="3" y="8" width="18" height="4.5" rx="1"/><path d="M5 12.5V20h14v-7.5M12 8v12"/>' +
      '<path d="M12 8S10.6 4 8.1 4a2 2 0 0 0 0 4M12 8s1.4-4 3.9-4a2 2 0 0 1 0 4"/></svg>';
  }

  function sized(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function progressHtml(count) {
    if (!offer.enabled) return '';
    var rem = count % bundle;
    var filled = count > 0 && rem === 0 ? bundle : rem;
    var label = esc(cfg.offerLabel || '3x2');
    var msg;
    if (count === 0) {
      msg = 'Añade ' + bundle + ' packs y paga solo ' + offer.buy + '.';
    } else if (rem === 0) {
      var free = freeFor(count);
      msg = '<strong>' + label + ' aplicado:</strong> ' + free + (free === 1 ? ' pack gratis' : ' packs gratis') +
        (gift.enabled ? ' y ' + esc(gift.name) + '.' : '.');
    } else {
      var need = bundle - rem;
      msg = need === 1
        ? 'Añade <strong>1 pack más</strong> y te sale gratis.'
        : 'Añade <strong>' + need + ' packs más</strong> y el ' + bundle + 'º te sale gratis.';
    }
    var segs = '';
    for (var i = 0; i < bundle; i++) {
      segs += '<span class="progress__seg' + (i < filled ? ' is-full' : '') + (i === bundle - 1 ? ' is-free' : '') + '"></span>';
    }
    return '<div class="progress"><div class="progress__segs" style="--n:' + bundle + '" aria-hidden="true">' + segs + '</div>' +
      '<p class="progress__msg">' + msg + '</p></div>';
  }

  function lineHtml(item) {
    var img = item.image
      ? '<img src="' + esc(sized(item.image, 160)) + '" alt="" width="72" height="72" loading="lazy">'
      : '';
    var hasVariant = item.variant_title && item.variant_title !== 'Default Title' && !item.product_has_only_default_variant;
    var variant = hasVariant ? '<p class="line__variant">' + esc(item.variant_title) + '</p>' : '';
    var discounts = (item.line_level_discount_allocations || []).map(function (a) {
      var title = a.discount_application && a.discount_application.title ? a.discount_application.title : 'Descuento';
      return '<span class="line__discount">' + esc(title) + '</span>';
    }).join('');
    var strike = item.original_line_price !== item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
    var key = esc(item.key);
    return '<li class="line">' +
      '<div class="line__img">' + img + '</div>' +
      '<div class="line__info">' +
        '<a class="line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
        '<div class="qty" role="group" aria-label="Cantidad de ' + esc(item.product_title) + '">' +
          '<button type="button" class="qty__btn" data-line-key="' + key + '" data-line-qty="' + (item.quantity - 1) + '" aria-label="Quitar un pack">&minus;</button>' +
          '<span class="qty__val">' + item.quantity + '</span>' +
          '<button type="button" class="qty__btn" data-line-key="' + key + '" data-line-qty="' + (item.quantity + 1) + '" aria-label="Añadir un pack">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="line__price">' + strike + '<strong>' + formatMoney(item.final_line_price) + '</strong>' + discounts + '</div>' +
    '</li>';
  }

  function giftLineHtml() {
    return '<li class="line line--gift">' +
      '<div class="line__img">' + (gift.image ? '<img src="' + esc(gift.image) + '" alt="" width="72" height="72" loading="lazy">' : giftIcon()) + '</div>' +
      '<div class="line__info"><p class="line__title">' + esc(gift.title || cap(gift.name)) + '</p>' +
      '<p class="line__variant">Va dentro de tu caja</p></div>' +
      '<div class="line__price"><strong>Gratis</strong></div></li>';
  }

  function footHtml(cart) {
    if (!cart.item_count) return '';
    var rows = '';
    if (cart.total_discount > 0) {
      rows += '<div class="sum__row"><span>Precio sin oferta</span><span>' + formatMoney(cart.original_total_price) + '</span></div>';
      rows += '<div class="sum__row sum__row--save"><span>Ahorras</span><span>&minus;' + formatMoney(cart.total_discount) + '</span></div>';
    }
    if (cfg.freeShipping) rows += '<div class="sum__row"><span>Envío</span><span>Gratis</span></div>';
    rows += '<div class="sum__row sum__row--total"><span>Total</span><span>' + formatMoney(cart.total_price) + '</span></div>';
    return '<div class="sum">' + rows + '</div>' +
      '<form action="' + esc(routes.cart) + '" method="post">' +
        '<button type="submit" name="checkout" class="btn btn--primary btn--block btn--xl">Finalizar pedido</button>' +
      '</form>' +
      '<p class="drawer__note">Pago seguro' + (cfg.deliveryLabel ? '. Entrega en ' + esc(cfg.deliveryLabel) : '') + '.</p>' +
      '<p class="drawer__error" data-drawer-error role="alert" hidden></p>';
  }

  function renderCart(cart) {
    if (!cart) return;
    updateCount(cart.item_count);
    if (!drawer) return;
    var count = cart.item_count;
    var progress = $('[data-cart-progress]', drawer);
    if (progress) progress.innerHTML = progressHtml(count);

    var list = $('[data-cart-items]', drawer);
    if (list) {
      if (count) {
        var html = cart.items.map(lineHtml).join('');
        if (gift.enabled && freeFor(count) > 0) html += giftLineHtml();
        list.innerHTML = html;
      } else {
        list.innerHTML = '<li class="cart-empty"><p>Tu carrito está vacío.</p>' +
          '<a class="btn btn--ink" href="' + esc(cfg.emptyCartUrl || routes.root) + '">Ver los packs</a></li>';
      }
    }

    var upsell = $('[data-cart-upsell]', drawer);
    if (upsell) {
      var rem = count % bundle;
      upsell.hidden = offer.enabled && count > 0 && rem === 0;
      var title = $('[data-upsell-title]', upsell);
      if (title) {
        if (count === 0) title.textContent = 'Empieza por un pack';
        else if (offer.enabled) title.textContent = 'Completa tu ' + (cfg.offerLabel || '3x2');
        else title.textContent = 'Añade otro pack';
      }
    }

    var foot = $('[data-cart-foot]', drawer);
    if (foot) foot.innerHTML = footHtml(cart);
  }

  function showDrawerError(error) {
    var el = drawer ? $('[data-drawer-error]', drawer) : null;
    var message = (error && error.message) || 'No se pudo actualizar el carrito.';
    if (el) { el.textContent = message; el.hidden = false; }
    else window.alert(message);
  }

  function refreshCart() { return cartGet().then(function (cart) { renderCart(cart); return cart; }); }

  function openDrawer() {
    if (!useDrawer) { window.location.href = routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (panel) panel.focus();
    });
    document.body.classList.add('is-locked');
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    window.setTimeout(function () { drawer.hidden = true; }, 280);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function trapFocus(event) {
    if (!panel) return;
    var focusables = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  }

  /* ---------- Global events ---------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cart-toggle]');
    if (toggle && useDrawer) {
      event.preventDefault();
      openDrawer();
      refreshCart().catch(function () {});
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var qtyBtn = event.target.closest('[data-line-key]');
    if (qtyBtn) {
      event.preventDefault();
      qtyBtn.disabled = true;
      cartChange(qtyBtn.getAttribute('data-line-key'), parseInt(qtyBtn.getAttribute('data-line-qty'), 10))
        .then(renderCart)
        .catch(function (error) { qtyBtn.disabled = false; showDrawerError(error); });
      return;
    }

    var chip = event.target.closest('[data-quick-variant]');
    if (chip) {
      event.preventDefault();
      chip.classList.add('is-loading');
      var fd = new FormData();
      fd.append('id', chip.getAttribute('data-quick-variant'));
      fd.append('quantity', '1');
      cartAdd(fd)
        .then(refreshCart)
        .catch(showDrawerError)
        .then(function () { chip.classList.remove('is-loading'); });
      return;
    }

    var sticky = event.target.closest('[data-sticky-submit]');
    if (sticky) {
      var form = document.getElementById(sticky.getAttribute('data-form'));
      if (form) {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer || drawer.hidden) return;
    if (event.key === 'Escape') closeDrawer();
    if (event.key === 'Tab') trapFocus(event);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-quick-add], [data-product-form]')) return;
    var items = typeof form.__items === 'function' ? form.__items() : null;
    if (!useDrawer && !items) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var error = form.querySelector('[data-form-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    var request = items && items.length ? cartAddItems(items) : cartAdd(new FormData(form));
    request
      .then(function () {
        if (!useDrawer) { window.location.href = routes.cart; return null; }
        return refreshCart().then(openDrawer);
      })
      .catch(function (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
        else window.alert(err.message);
      })
      .then(function () {
        if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      });
  });

  /* ---------- Product cards: price follows the chosen flavour ---------- */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-pack-card] input[name="id"]')) return;
    var card = input.closest('[data-pack-card]');
    var price = Number(input.getAttribute('data-price'));
    var priceEl = card ? $('[data-card-price]', card) : null;
    var unitEl = card ? $('[data-card-unit]', card) : null;
    if (priceEl && price) priceEl.innerHTML = formatMoney(price);
    if (unitEl && price) unitEl.innerHTML = formatMoney(Math.floor(price / (offer.unitsPerPack || 24))) + ' por lata';
  });

  /* ---------- Product page: gallery, bundle builder ---------- */
  function initGallery(section) {
    var gallery = $('[data-gallery]', section);
    if (!gallery) return null;
    var slides = $$('.product__slide', gallery);
    var thumbs = $$('[data-thumb]', section);
    function go(index, smooth) {
      var slide = slides[index];
      if (!slide) return;
      gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    var ticking = false;
    gallery.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        ticking = false;
      });
    });
    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); return; }
        }
      }
    };
  }

  function initProduct(section) {
    if (section.__ready) return;
    section.__ready = true;
    var gallery = initGallery(section);
    var bundleEl = $('[data-bundle]', section);
    var form = $('[data-product-form]', section);
    if (!form) return;

    var idInput = $('[data-variant-id]', form);
    var qtyInput = $('[data-qty-input]', form);
    var addButton = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var stickyLabel = $('[data-sticky-label]', section);
    var slots = bundleEl ? $$('[data-slot]', bundleEl) : [];
    var offerRadios = bundleEl ? $$('[data-offer-radio]', bundleEl) : [];

    function quantity() {
      var checked = offerRadios.filter(function (r) { return r.checked; })[0];
      if (checked) return parseInt(checked.value, 10) || 1;
      return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    }

    function selection(q) {
      var list = [];
      if (slots.length) {
        for (var i = 0; i < q && i < slots.length; i++) {
          var sel = $('[data-slot-select]', slots[i]);
          var opt = sel.options[sel.selectedIndex];
          list.push({ id: sel.value, price: Number(opt.getAttribute('data-price')) || 0, available: !opt.disabled });
        }
      } else if (idInput) {
        for (var n = 0; n < q; n++) list.push({ id: idInput.value, price: 0, available: true });
      }
      return list;
    }

    function totalFor(list) {
      var prices = list.map(function (x) { return x.price; }).sort(function (a, b) { return a - b; });
      var free = freeFor(prices.length);
      var sum = 0;
      for (var i = free; i < prices.length; i++) sum += prices[i];
      return sum;
    }

    function refresh() {
      var q = quantity();
      slots.forEach(function (slot, i) { slot.hidden = i >= q; });
      offerRadios.forEach(function (r) {
        var card = r.closest('.offer-card');
        if (card) card.classList.toggle('is-selected', r.checked);
      });
      var list = selection(q);
      var ok = list.length > 0 && list.every(function (x) { return x.available; });
      if (idInput && list[0]) idInput.value = list[0].id;
      if (qtyInput) qtyInput.value = q;
      var label = ok && list[0].price
        ? 'Añadir ' + q + (q === 1 ? ' pack' : ' packs') + ' por ' + formatMoney(totalFor(list))
        : (ok ? 'Añadir al carrito' : 'Agotado');
      if (addLabel) addLabel.textContent = label;
      if (stickyLabel) stickyLabel.textContent = label;
      if (addButton) addButton.disabled = !ok;
    }

    offerRadios.forEach(function (r) { r.addEventListener('change', refresh); });
    slots.forEach(function (slot) {
      var sel = $('[data-slot-select]', slot);
      var img = $('[data-slot-img]', slot);
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (img && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
        if (gallery) gallery.showMedia(opt.getAttribute('data-media-id'));
        refresh();
      });
    });

    // Items sent to the cart: one line per flavour, grouped.
    form.__items = function () {
      var grouped = {};
      var order = [];
      selection(quantity()).forEach(function (x) {
        if (!grouped[x.id]) { grouped[x.id] = 0; order.push(x.id); }
        grouped[x.id] += 1;
      });
      return order.map(function (id) { return { id: Number(id), quantity: grouped[id] }; });
    };

    var sticky = $('[data-sticky-buy]', section);
    if (sticky && addButton && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }).observe(addButton);
    }

    refresh();
  }

  /* ---------- Delivery date ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      added++;
    }
    return d;
  }
  function initDelivery() {
    $$('[data-delivery]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-days'), 10) || 3;
      var prefix = el.getAttribute('data-prefix');
      if (!prefix || typeof Intl === 'undefined') return;
      try {
        var text = new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })
          .format(addBusinessDays(new Date(), days));
        el.innerHTML = esc(prefix) + ' <strong>' + esc(text) + '</strong>';
      } catch (e) { /* deja el texto de respaldo */ }
    });
  }

  /* ---------- Init ---------- */
  function init() {
    var initial = document.getElementById('CartInitial');
    if (initial) {
      try { renderCart(JSON.parse(initial.textContent)); } catch (e) { /* ignorar */ }
    }
    $$('[data-product-section]').forEach(initProduct);
    initDelivery();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    $$('[data-product-section]', event.target).forEach(initProduct);
    initDelivery();
  });
})();
